import { ReactNode, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import "./modalConfirm.css";

interface PropsI {
  show: boolean;
  title?: string;
  message?: ReactNode;
  actionLabel?: string;
  data?: any;
  onClose: () => void;
  onConfirm: () => void;
}

export const RawModalConfirm = ({
  onClose,
  onConfirm,
  show,
  title = "Atención",
  message,
  actionLabel = "Confirmar",
}: PropsI) => {

  const handleClickConfirmar = () => {
    onClose();
    onConfirm();
  };

  return (
    <>
      <Modal
        className="modal-confirm"
        centered
        show={show}
        onHide={onClose}
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <div className="modal-confirm-message">
                {message ?? <p>¿Deseas confirmar la accion?</p>}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex gap-2">
          <Button variant="light" size={"lg"} onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            size={"lg"}
            onClick={handleClickConfirmar}
            disabled={false}
          >
            {actionLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
